<template>

<div id="skills_tab" class="flex_content scores_table_container">
        <div class="container data_table_view">
            <div v-if="dataLoaded">

                <div class="show_compare_chart_container" v-if="refEvaluation.saven_test.custom_skills_data.length > 2">
                    <div class="show_compare_chart_button">
                        <button class="button is-outlined is-info table-button" @click="openSkillsCompareModal">
                            {{ $t("modules.positions.evals_detail.showChart") }}
                        </button>
                    </div>
                    <SkillsCompareModal :opened="SkillsCompareModalOpened"
                        @closeSendReport="closeSkillsCompareModal"
                        :BaseSkillData="refEvaluation.saven_test.custom_skills_data"
                        :evaluations="evaluations"
                        skillsKey="custom_skills_data"
                        :selectedEvaluationsIds="selectedPositionEvals" />
                </div>

                <TableWrapper tableContainerId="positions_table_container" v-if="currentRef" class="with_shadow">

                    <template v-slot:tableHead>

                        <tr>
                            <th></th>
                            <th class="eval_username">{{ $t('modules.positions.evals_detail.candidates') }}</th>
                            <th v-if="dimensionsPlan.custom_skills_settings.ui_show_matching"
                                :class="matchingSortingActive()"
                                class="sortable_column"
                                data-tooltip="Score de matching"
                                @click="reorderEval('custom_skills_matching')">%</th>
                            <th :class="activeSortingClass(data.code_name)"
                                class="sortable_column"
                                :data-tooltip="data.name[$i18n.locale] "
                                v-for="(data, index) in refEvaluation.saven_test.custom_skills_data"
                                :index="index" :key="data.code_name"
                                @click="reorderEval(data.code_name)">
                                    <span>{{ data.name[$i18n.locale].slice(0,4) }}</span>
                            </th>
                        </tr>
                    </template>

                    <template v-slot:tableBody>

                        <tr class="ref_line" v-if="dimensionsPlan.custom_skills_settings.ui_show_ref">
                            <th></th>
                            <td class="eval_username">{{ $t('modules.positions.evals_detail.ref_score') }}</td>
                            <td v-if="dimensionsPlan.custom_skills_settings.ui_show_matching">-</td>
                            <td v-for="(data, index) in refEvaluation.saven_test.custom_skills_data"
                                :index="index" :key="data.code_name">
                                <div class="ref_score">{{ data.ref_score.toFixed(0) }}</div>
                            </td>
                        </tr>

                        <tr class="evalution_item_name"
                            v-for="(evaluation, index) in evaluations"
                            :index="index" :key="evaluation.id" >
                            <td>
                                <TableSelectCheckbox :checkboxId=" 'select_' + evaluation.id"
                                    @change="checkSelectedEval($event, evaluation.id)"
                                    :isChecked="isSelected(evaluation.id)" />
                            </td>

                            <td class="eval_username">
                                <router-link :to=" '/evaluations/' + evaluation.id ">
                                    {{ evaluation.candidate_username }}
                                </router-link>
                            </td>

                            <td v-if="dimensionsPlan.custom_skills_settings.ui_show_matching"
                                class="matching_col"
                                :class="matchingClass(evaluation.saven_test.custom_skills_matching.toFixed(0))">
                                {{ evaluation.saven_test.custom_skills_matching.toFixed(0) }}%
                            </td>

                            <td
                                v-for="(data, key) in evaluation.saven_test.custom_skills_data"
                                :index="key" :key="key" >
                                <div :class="proximityClass(data.score, data.ref_score)" class="circle_score">{{ data.score.toFixed(0) }}</div>
                            </td>
                        </tr>

                    </template>

                </TableWrapper>

            </div>
        </div>
    </div>
</template>

<script>

import SkillsCompareModal from './skillsCompareModal'


export default {
    name: 'CustomSkillsTab',
    props: ["evaluations", "currentPosition", "currentRef", "dataLoaded", "selectedPositionEvals"],
    components: {
        SkillsCompareModal
    },
    data(){
        return {
            current_sorting: null,
            SkillsCompareModalOpened: false
        }
    },
    computed: {
        refEvaluation(){
            return this.evaluations[0]
        },
        dimensionsPlan(){
            return this.currentPosition.dimensions_plan
        }
    },
    methods: {
        openSkillsCompareModal(position){
            this.SkillsCompareModalOpened = true
        },
        closeSkillsCompareModal(position){
            this.SkillsCompareModalOpened = false
        },
        isSelected(evaluationId){
            return this.$store.state.PositionStore.SelectedPositionEvalsIds.includes(evaluationId)
        },
        checkSelectedEval(isChecked, evaluationId){
            this.$emit("SelectionCheckBoxClicked",{isChecked: isChecked, evaluationId: evaluationId} )
        },
        reorderEval(key){
            this.current_sorting = key
            this.$emit('reorderEval', key)
        },
        activeSortingClass(key){
            if (key  == this.current_sorting){
                return 'active'
            }else{
                return ''
            }
        },
        matchingSortingActive(){
            if ('custom_skills_matching' == this.current_sorting){
                return 'active'
            }else{
                return ''
            }
        },
        proximityClass(score, ref_score){
            if(this.dimensionsPlan.custom_skills_settings.ui_show_ref){
                const prox = Math.abs(ref_score.toFixed(0) - score.toFixed(0))
                return "proximity_" + prox
            }else{
                return "no_ref_score"
            }
        },
        key_trad(key){
            const trad = 'dimensions.skills_short.' + key
            return this.$t(trad)
        },
        tooltipLabel(key){

            return s3SkillsLabels[this.$i18n.locale][key]

        },
        matchingClass(val){
            if(val < 25){return 'low'}
            if(val >= 25 && val < 50){return 'middleLow'}
            if(val >= 50 && val < 75){return 'middleHigh'}
            if(val >= 75){return 'high'}
        }


    }
}
</script>

<style lang="scss">

</style>